import React, { Component } from 'react';
import { TeamUsersList } from './team-users-list/TeamUsersList';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchTeamDetails } from '../redux/team-details/actions';
import { getTeamDetails } from '../redux/team-details/selectors';
import * as _ from 'lodash';
import AddUserEditTeamModal from '../../user/add-user-to-team/add-user-to-team-modal/AddUserEditTeamModal';
import { AddButton } from '../../../../../shared/button/AddButton';
import { BackButton } from '../../../../../shared/button/back-button/BackButton';
import { removeUserFromTeam } from '../../user/redux/update-user/actions';
import { EditButton } from '../../../../../shared/button/EditButton';
import { getUsersListState } from '../../user/redux/user-list/selectors';
import { extendWithModalSupport } from '../../../../../shared/modal-container/ModalContainer';
import { fetchUsers } from '../../user/redux/user-list/actions';
import { PageActionsRow } from '../../../../../shared/headers/PageActionsRow';
import TeamJurisdictions from './team-jurisdictions/TeamJurisdictions';

export const TeamDetailsModalMode = Object.freeze({
    ADD: 'ADD',
    EDIT: 'EDIT'
});

class TeamDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalMode: null
        };
        extendWithModalSupport(this);
    }

    getFilteredUsersForTeam = teamId => {
        return (
            this.props.users &&
            this.props.users.filter(user =>
                user.belongsInTeams.find(team => team.id === teamId)
            )
        );
    };

    componentDidMount() {
        const { teamId } = this.props.match.params;

        teamId &&
            _.isFunction(this.props.fetchTeamDetails) &&
            this.props.fetchTeamDetails(teamId);

        _.isFunction(this.props.fetchUsers) && this.props.fetchUsers();
    }

    handleRemoveUser = (userId, teamId) => {
        _.isFunction(this.props.removeUserFromTeam) &&
            this.props.removeUserFromTeam(userId, teamId);
    };

    openModal = modalMode => {
        this.setState(
            {
                ...this.state,
                modalMode
            },
            this.modalInstance.openModal()
        );
    };

    render = () => {
        const { team, users, loading } = this.props;

        return (
            team && (
                <div className={'team-details container'}>
                    <PageActionsRow>
                        <AddButton
                            key={`Add-${team.id}`}
                            onClick={() =>
                                this.openModal(TeamDetailsModalMode.ADD)
                            }
                            label={'Add User'}
                        />
                        <EditButton
                            key={`Edit-${team.id}`}
                            onClick={() =>
                                this.openModal(TeamDetailsModalMode.EDIT)
                            }
                        />
                        <BackButton />
                    </PageActionsRow>

                    {users && (
                        <TeamUsersList
                            loading={loading}
                            users={this.getFilteredUsersForTeam(team.id)}
                            removeUserFromTeam={user =>
                                this.handleRemoveUser(user.id, team.id)
                            }
                        />
                    )}

                    {team.jurisdictions && (
                        <TeamJurisdictions
                            teamId={team.id}
                            teamJurisdictions={team.jurisdictions}
                        />
                    )}

                    <AddUserEditTeamModal
                        team={this.props.team}
                        users={this.props.users}
                        ref={this.modalRef}
                        mode={this.state.modalMode}
                    />
                </div>
            )
        );
    };
}

const mapStateToProps = state => {
    const team = getTeamDetails(state);
    const users = getUsersListState(state);
    return {
        team,
        users: users.data,
        loading: users.loading
    };
};

const mapDispatchToProps = dispatch => ({
    fetchTeamDetails: teamId => dispatch(fetchTeamDetails(teamId)),
    fetchUsers: () => dispatch(fetchUsers()),
    removeUserFromTeam: (userId, teamId) =>
        dispatch(removeUserFromTeam({ userId, teamId }))
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TeamDetails)
);
